import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stay-signin',
  templateUrl: './stay-signin.component.html',
  styleUrls: ['./stay-signin.component.scss']
})
export class StaySigninComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
